import { ActionIcon, Group, Paper, Textarea } from '@mantine/core';
import { IconTrash } from '@tabler/icons-react';
import classes from './BrandIdentity.module.css';

// One audience, edited in place. Removing it only changes the unsaved draft, so there is no confirm.
const AudienceCard = ({ index, audience, onChange, onRemove }) => (
  <Paper withBorder radius="md" p="sm">
    <Group gap={4} wrap="nowrap" align="flex-start">
      {/* Wraps instead of scrolling sideways: a long name stays readable without focusing it. */}
      <Textarea
        flex={1}
        variant="unstyled"
        size="sm"
        autosize
        minRows={1}
        maxRows={3}
        aria-label={`Audience ${index + 1} name`}
        placeholder="Name this audience"
        value={audience.title || ''}
        onChange={(e) => onChange('title', e.target.value.replace(/\n/g, ' '))}
        styles={{ input: { fontWeight: 600, minHeight: 0, lineHeight: 1.4, paddingTop: 0, paddingBottom: 0 } }}
      />
      <ActionIcon
        variant="subtle"
        color="gray"
        size="sm"
        className={classes.remove}
        aria-label={`Remove audience ${index + 1}`}
        onClick={onRemove}
      >
        <IconTrash size={16} />
      </ActionIcon>
    </Group>
    <Textarea
      variant="unstyled"
      size="sm"
      autosize
      minRows={2}
      maxRows={6}
      aria-label={`Audience ${index + 1} description`}
      placeholder="Who they are and what they care about"
      value={audience.description || ''}
      onChange={(e) => onChange('description', e.target.value)}
      styles={{ input: { color: 'var(--mantine-color-dimmed)', paddingTop: 0 } }}
    />
  </Paper>
);

export default AudienceCard;
